import { FC, ReactNode } from "react";

/**
 * A titled group of fields inside a form: heading, optional one-line hint, optional trailing
 * action, then the fields. Groups are separated by a hairline, not by cards — `FormSection`'s
 * white card inside a white modal was a container with nothing to contain.
 *
 * Used by both upsert forms (`features/appointment-upsert`, `features/task-upsert`) and by the
 * shared `ScheduleFields`, so the three sections of either form read as one document.
 */
interface Props {
  title: string;
  hint?: string;
  action?: ReactNode;
  children: ReactNode;
}

export const FieldGroup: FC<Props> = ({ title, hint, action, children }) => (
  <section className="flex flex-col gap-4 border-t border-slate-200 pt-6 first:border-0 first:pt-0">
    <div className="flex items-start justify-between gap-4">
      <div className="flex flex-col gap-0.5">
        <h3 className="font-['Roboto'] text-[15px] font-bold leading-none text-[#124093]">
          {title}
        </h3>
        {hint && <p className="text-xs text-slate-400">{hint}</p>}
      </div>
      {action}
    </div>
    {children}
  </section>
);
